import styled from "styled-components";
import Logo from "src/assets/logo.svg";

export const StyledFooter = styled("section")(
  ({ theme }) => `
  background: ${theme.colorBgLayout};
  padding-block: 64px;
  padding-inline: 48px;
`,
);

export const BrandContainer = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const LogoImage = styled(Logo)({
  height: 25,
  width: 165,
});

export const BrandDescription = styled("p")(
  ({ theme }) => `
  font-size: 14px;
  line-height: 1.6;
  color: ${theme.colorTextSecondary};
  margin: 0;
`,
);

export const SocialLinks = styled("div")`
  display: flex;
  gap: 16px;
  margin-top: 8px;
`;

export const SocialIcon = styled("span")(
  ({ theme }) => `
  font-size: 20px;
  color: ${theme.colorPrimary};
  cursor: pointer;
  transition: color 0.3s;

  &:hover {
    color: ${theme.colorPrimaryHover};
  }
`,
);

export const FooterSection = styled("div")`
  display: flex;
  flex-direction: column;
`;

export const FooterTitle = styled("h4")(
  ({ theme }) => `
  font-size: 16px;
  font-weight: 600;
  color: ${theme.colorText};
  margin-bottom: 16px;
`,
);

export const FooterLinks = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const FooterLink = styled("a")(
  ({ theme }) => `
  font-size: 14px;
  color: ${theme.colorTextSecondary};
  text-decoration: none;
  transition: color 0.3s;

  &:hover {
    color: ${theme.colorPrimary};
  }
`,
);

export const CopyrightBar = styled("div")(
  ({ theme }) => `
  background: ${theme.colorBgContainer};
  padding-block: 24px;
  padding-inline: 24px;
  border-top: 1px solid ${theme.colorBorder};
`,
);

export const CopyrightContent = styled("div")`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
`;

export const CopyrightText = styled("p")(
  ({ theme }) => `
  font-size: 14px;
  color: ${theme.colorTextSecondary};
  margin: 0;
`,
);

export const LegalLinks = styled("div")`
  display: flex;
  gap: 24px;
`;

export const LegalLink = styled("a")(
  ({ theme }) => `
  font-size: 14px;
  color: ${theme.colorTextTertiary};
  text-decoration: none;
  transition: color 0.3s;

  &:hover {
    color: ${theme.colorPrimary};
  }
`,
);
